import { createContext } from 'react';
import type { InterruptedToolAction } from './interrupted-action';

export type InterruptedActionValue = {
  /** The tool call currently offered for resume, or `null` when none applies. */
  activeToolCallId: string | null;
  onResume: (action: InterruptedToolAction) => void;
  onSkip: (action: InterruptedToolAction) => void;
  /** Answer an interrupted question by continuing the conversation with the reply. */
  onAnswer: (toolCallId: string, answer: string) => void;
  /** Answer a live question (agent waiting now) by submitting the chosen reply. */
  onAnswerQuestion: (toolCallId: string, answer: string) => void;
};

/**
 * Lets a deep `DynamicTool` card offer "resume / skip" buttons for a cut-off
 * tool call without threading handlers through the whole transcript. Providers
 * are scoped per conversation pane so each pane resumes its own action.
 */
export const InterruptedActionContext = createContext<InterruptedActionValue | null>(null);
